/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
/** @jsxImportSource @emotion/react */
import styled from "@emotion/styled";
import parse from "html-react-parser";
import { useRef } from "react";
import { CSSTransition } from "react-transition-group";
import RewardsButton from "./RewardsButton";
import { fromPublic, getPlatformFormattedText } from "../../utils";

const StyledTransitionWrapper = styled.div`
  .transition {
    &-enter {
      transform: translateY(100%);
    }

    &-enter-active {
      transform: translateY(0);
      transition: transform 200ms ease-out;
    }

    &-enter-done {
      transform: translateY(0);
    }

    &-exit {
      transform: translateY(0);
    }

    &-exit-active {
      transform: translateY(100%);
      transition: transform 200ms ease-in;
    }
    &-exit-done {
      transform: translateY(100%);
    }
  }
`;

const StyledHintCard = styled.div`
  position: fixed;
  width: 100%;
  left: 0;
  flex-direction: column;
  display: flex;
  background-color: #ffffff;
  border-top-left-radius: 18px;
  border-top-right-radius: 18px;
  transform: translateY(100%); // Hide the card so it's ready for transition.
  bottom: 0;
  z-index: 100;
  padding-bottom: env(safe-area-inset-bottom); // Ensure content respects safe area bottom
`;

const StyledContent = styled.div`
  padding: 16px;
  flex-direction: column;
  display: flex;
  align-items: center;
  text-align: center;

  img {
    margin-top: 12px;
  }

  p {
    margin-top: 8px;
    margin-bottom: 0;
  }
`;

const StyledButton = styled(RewardsButton)`
  margin-top: 18px;
  margin-bottom: 18px;
`;

interface HintCardProps {
    readonly show: boolean;
    readonly onClose: () => void;
    readonly title: string;
    readonly image: string;
    readonly content: string;
    readonly buttonText: string;
    readonly className?: string;
}

function HintCard({ show, onClose, title, image, content, buttonText, className }: HintCardProps) {
  const ref = useRef<HTMLDivElement>(null);

  return (
    <StyledTransitionWrapper>
      <CSSTransition in={show} timeout={200} classNames="transition" nodeRef={ref}>
        <StyledHintCard ref={ref} className={className}>
          <StyledContent>
            {parse(title)}
            <img src={fromPublic(image)} />
            {parse(content)}
            <StyledButton clickHandler={onClose}>{getPlatformFormattedText(buttonText)}</StyledButton>
          </StyledContent>
        </StyledHintCard>
      </CSSTransition>
    </StyledTransitionWrapper>
  );
}

export default HintCard;
